import React, { memo, useEffect, useState } from 'react';
import cls from './MenuBar.module.scss';
import { CartMenuEntry, CompanyHomeMenuEntry, DashboardMenuEntry, HelloNameMenuEntry, MainMenuEntry, MobileMainMenuEntry, ModulesMenuEntry, ProcessMenuEntry, SingleNavigateModule } from '../../HeaderMenuButtons/HeaderMenuButtons';
import { LogoutModal, ModalR, PermissionWrapper, po } from '../../../common';
import { useSelector } from 'react-redux';
import { store } from '../../../../reduxStore/store';
import { setCurrentTask, setProcessModule } from '../../../../reduxStore/actions/flowActions';
import { isMobile } from 'react-device-detect';
import { FLOWHERO } from '../../../../shared/utility';
import ModulesMenu from '../../../SideMenuEntries/ModulesMenu';

const MenuBar = () => {
	const [userLogout, setUserLogout] = useState(false);

	const { allModules, cart, companyData, showSideMenu } = useSelector(store => store.flowReducer);
	const { user } = useSelector(store => store.sessionReducer);
	const [showAbout, setShowAbout] = useState(false);


	useEffect(() => {
		if (allModules.length == 1) {
			store.dispatch(setCurrentTask(undefined));
			store.dispatch(
				setProcessModule({
					...allModules[0].procedure,
					stepIndex: 0,
					module_id: allModules[0].id,
					module: allModules[0],
				})
			);
		}
	}, [allModules]);

	const AboutR = () => {
		return (
			<div style={{ margin: 'auto', color: 'var(--app-color-gray-dark)', padding: '0px 40px 40px 40px', fontFamily: 'var(--app-text-main-font)', fontWeight: 'bold' }}>
				{FLOWHERO('28px', 'var(--app-color-gray-dark)', 'bold')}
				<p style={{ fontFamily: 'var(--app-text-main-font)', fontWeight: 'bold', color: 'var(--app-color-gray-dark)' }}>
					{`© 2020-2025 FlowHeroApps Solutions. All rights reserved.`}
				</p>
			</div>
		);
	};

	return (
		<div className={cls.menuBar} style={{ backgroundColor: 'var(--app-color-gray-dark)', color: 'white', ...(companyData?.company_standards?.themeJ ?? {}),position: user?.id ? 'absolute':'absolute' }}>
			<nav className={cls.nav} >
				<div style={{ display: 'flex', marginLeft: '2%', userSelect: 'none', alignItems: 'center', padding: '4px 0' }}>


					<div style={{ alignItems: 'center', display: 'flex' }}>
						{companyData?.logo ?
							<img alt="lg" src={companyData?.logo} className={isMobile ? cls.logoUrlImgMobile : cls.logoUrlImgMobile} />
							:
							<div style={{ padding: '0 0 5px 20px' }}>
								{FLOWHERO('18px', 'white', 'bold')}
								<div style={{ fontSize: isMobile ?'10px': '16px', fontWeight: 'normal' }}>
									{companyData?.display_name}
								</div>
							</div>
						}
					</div>
					{companyData?.logo &&

						<div style={{ padding: isMobile ? '0 10px' : '0 20px', alignItems: 'center', display: 'flex' }}>
							<div style={{ fontSize: isMobile ? '14px' : '18px', fontWeight: 'normal', ...(companyData?.company_standards?.themeJ ?? {}) }}>
								{companyData?.display_name}
							</div>
						</div>
					}


				</div>

				<div className={cls.ul} style={{padding: '0px 0 5px'}}>
					{!isMobile && <PermissionWrapper permissions={[po.blueprints.process.create]}>
							<DashboardMenuEntry />
						</PermissionWrapper>}

					{!isMobile &&
							allModules?.length == 1 &&
							<ModulesMenu inner={true} />
						}
						<PermissionWrapper permissions={[po.blueprints.process.create]}>
							{(companyData.status === 'active' || companyData.status === 'on_trial' || companyData.status === 'free' || companyData.status === 'superadmin')
								&& !isMobile &&
								<ProcessMenuEntry />}
						</PermissionWrapper>


					{cart?.items?.length > 0 ? <CartMenuEntry orders={cart} companyData={companyData} /> : !isMobile &&
						<HelloNameMenuEntry message={`Hello, ${user?.first_name ?? 'Future User'} ${user?.last_name ?? ''}`} />}
					<MainMenuEntry userLogout={userLogout} setUserLogout={setUserLogout} onAboutClick={() => setShowAbout(true)}
						showBilling={user.is_admin || allModules.filter(mod => mod.options?.credits == true).length > 0}
						logo={user?.photo ? <div className={cls.avatarContentContainer}><img src={user?.photo} className={cls.avatarUrlImg} /></div> : undefined} />
				</div>
				
				{userLogout && <LogoutModal openModal={userLogout} setOpenModal={setUserLogout} slug={companyData?.slug} />}
				{showAbout && (
					<ModalR blured={true} hasCloseIcon scrollable={true} isOpen={showAbout} onClose={() => setShowAbout(false)} shadowedContainerStyle={{ minWidth: '400px', width: '30%', height: 'auto' }}>
						<AboutR />
					</ModalR>
				)}
			</nav>
			{showSideMenu && allModules?.length > 1 && <ModulesMenu full={isMobile} />}
		</div>
	);
};

export default MenuBar;

export const TopMenu = props => {
	
	const { allModules, showSideMenu } = useSelector(store => store.flowReducer);
	const { user } = useSelector(store => store.sessionReducer);
	const [showAbout, setShowAbout] = useState(false);
	const { companyData } = props;


	

	const AboutR = () => {
		return (
			<div style={{ margin: 'auto', color: 'var(--app-color-gray-dark)', padding: '0px 40px 40px 40px', fontFamily: 'var(--app-text-main-font)', fontWeight: 'bold' }}>
				{FLOWHERO('28px', 'var(--app-color-gray-dark)', 'bold')}
				<p style={{ fontFamily: 'var(--app-text-main-font)', fontWeight: 'bold', color: 'var(--app-color-gray-dark)' }}>
					{`© 2020-2025 FlowHeroApps Solutions. All rights reserved.`}
				</p>
			</div>
		);
	};

	return (
		<div className={cls.menuBar} style={{ backgroundColor: 'transparent', color: 'white' }}>
			<nav className={cls.nav} >
				
				<div className={cls.ul} style={{padding: '0px 0 5px',height:'60px'}}>
					
					<CompanyHomeMenuEntry companyData={companyData} onAboutClick={() => setShowAbout(true)}
						showBilling={user.is_admin || allModules.filter(mod => mod.options?.credits == true).length > 0}
						logo={user?.photo ? <div className={cls.avatarContentContainer}><img src={user?.photo} className={cls.avatarUrlImg} /></div> : undefined} />
				</div>
				{showAbout && (
					<ModalR blured={true} hasCloseIcon scrollable={true} isOpen={showAbout} onClose={() => setShowAbout(false)} shadowedContainerStyle={{ minWidth: '400px', width: '30%', height: 'auto' }}>
						<AboutR />
					</ModalR>
				)}
			</nav>
			
		</div>
	);
};

export const MobileMenuBar = props => {
	const [userLogout, setUserLogout] = useState(false);
	const { onTransactionsClick } = props;
	const { allModules, cart, companyData } = useSelector(store => store.flowReducer);
	const { user } = useSelector(store => store.sessionReducer);
	const [showAbout, setShowAbout] = useState(false);

	useEffect(() => {
		if (allModules.length == 1) {
			store.dispatch(setCurrentTask(undefined));
			store.dispatch(
				setProcessModule({
					...allModules[0].procedure,
					stepIndex: 0,
					module_id: allModules[0].id,
					module: allModules[0],
				})
			);
		}
	}, [allModules]);

	const AboutR = () => {
		return (
			<div style={{ alignSelf: 'center', color: 'var(--app-color-gray-dark)' }}>
				{FLOWHERO('28px', 'var(--app-color-gray-dark)', 'bold')}
				<p>{`© 2020-2025 FlowHeroApps Solutions. All rights reserved.`}</p>
			</div>
		);
	};
	return (
		<nav className={cls.nav} style={{ display: '', backgroundColor: 'white' }}>
			<ul className={cls.ul}>
				<MobileMainMenuEntry userLogout={userLogout} setUserLogout={setUserLogout} onAboutClick={() => setShowAbout(true)} onTransactionsClick={onTransactionsClick} />
			</ul>

			{userLogout && <LogoutModal openModal={userLogout} setOpenModal={setUserLogout} slug={companyData?.slug} />}
			{showAbout && (
				<ModalR blured={true} hasCloseIcon scrollable={true} isOpen={showAbout} onClose={() => setShowAbout(false)} shadowedContainerStyle={{ minWidth: '400px', width: '30%', height: 'auto' }}>
					<AboutR />
				</ModalR>
			)}
		</nav>
	);
};
